import { render, staticRenderFns } from "./GeneralAnnouncementCard.vue?vue&type=template&id=2ac2f3c1&scoped=true&"
import script from "./GeneralAnnouncementCard.vue?vue&type=script&lang=js&"
export * from "./GeneralAnnouncementCard.vue?vue&type=script&lang=js&"
import style0 from "./GeneralAnnouncementCard.vue?vue&type=style&index=0&id=2ac2f3c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac2f3c1",
  null
  
)

export default component.exports